import { useEffect, useRef, useState } from "react";
import gsap from "gsap";

export default function AnimatedSentencesWithIndent() {
    const line1Ref = useRef(null);
    const line2Ref = useRef(null);
    const line3Ref = useRef(null);

    const [first, setFirst] = useState("next level");
    const [second, setSecond] = useState("IT services");
    const [third, setThird] = useState("on us.");

    useEffect(() => {
        const tl = gsap.timeline({ defaults: { duration: 1.1, ease: "power2.out" } });

        tl.fromTo(line1Ref.current, { x: -200, opacity: 0, delay: 1 }, { x: 0, opacity: 1 })
            .fromTo(line2Ref.current, { x: -100, opacity: 0 }, { x: -3, opacity: 1 }, "+=0.1")
            .fromTo(line3Ref.current, { x: -50, opacity: 0 }, { x: 0, opacity: 1 }, "+=0.1").call(() => {

                setFirst((prev) => prev.slice(0, 3));
                setSecond((prev) => prev.slice(0, 2));
                setThird((prev) => prev.slice(1, 5));
            });

        // Fade to the middle
        tl.fromTo(line1Ref.current, { x: 0, opacity: 0 }, { x: 0, y: 50, opacity: 1, duration: 0.3 }, "+=0.1")
            .fromTo(line2Ref.current, { x: 0, opacity: 0 }, { x: -18, y: 5, opacity: 1, duration: 0.3 }, "+=0.1")
            .fromTo(line3Ref.current, { x: 0, opacity: 0 }, { x: 48, y: -40, opacity: 1, duration: 0.3 }, "+=0.1")
            .call(() => {
                // Set nexITus as one word instead of 3 seperate ones
                setFirst("nexITus");
                setSecond("");
                setThird("");
            });

        // // Move lines toward center
        // tl.to(line3Ref.current, { x: 160, duration: 0.3 }, "+=0.1")
        //     .to(line2Ref.current, { x: 122, duration: 0.3 }, "+=0.1") // Middle stays centered
        //     .to(line1Ref.current, { x: 100, duration: 0.3 }, "+=0.2")
        //     .call(() => {
        //         // Set nexITus as one word instead of 3 seperate ones
        //         setFirst("nexITus");
        //         setSecond("");
        //         setThird("");
        //     });

    }, []);

    return (
        <div className="flex items-center w-full block justify-center" >
            <div className="relative flex dark:bg-gray-900 dark:text-white mx-auto h-48 flex-col gap-px p-6 bg-white">
                <div className="relative block">

                    <div ref={line1Ref} className="text-4xl font-medium leading-tight pl-0">
                        {first}
                    </div>
                    <div ref={line2Ref} className="text-4xl font-medium leading-tight pl-16 ml-3">
                        {second}
                    </div>
                    <div ref={line3Ref} className="text-4xl font-medium leading-tight pl-10">
                        {third}
                    </div>
                </div>
            </div>
        </div>
    );
}
